/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretUpDown = createReactComponent("caret-up-down", "IconCaretUpDown", [
  ["path", { d: "M18 10l-6 -6l-6 6h12", key: "svg-0" }],
  ["path", { d: "M18 14l-6 6l-6 -6h12", key: "svg-1" }]
]);

export { IconCaretUpDown as default };
//# sourceMappingURL=IconCaretUpDown.js.map
